<template>
    <div class="main">
        <c-panel>
            <form-tarefa :paramId="$route.params.id"></form-tarefa>
        </c-panel>
    </div>
</template>
<script>

import formTarefa from "./form"

export default {
    components:{ 'form-tarefa': formTarefa }
}
</script>
